import { WAddress } from "@/types/address";
import request from ".";
import { isString, isStringEmpty } from "@/utils/checkTool";

const ADDRESS_URL = '/wms/address';

const APP_APIS = {
  addressList: ADDRESS_URL + '/list',
  addressAdd: ADDRESS_URL + '/add',
  addressUpdate: (id: string) => `${ADDRESS_URL}/${id}/update`,
  addressDel: (id: string) => `${ADDRESS_URL}/${id}/del`,
}

export const addressList = () => {
  return new Promise<Array<WAddress>>((resolve, reject) => {
    request<Array<WAddress>>(APP_APIS.addressList)
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const addressAdd = (address: WAddress) => {
  return new Promise<WAddress>((resolve, reject) => {
    request<WAddress, WAddress>(APP_APIS.addressAdd, { params: { body: address } })
      .then(res => resolve(res.body))
      .catch(err => reject(err))
  })
}

export const addressUpdate = (address: WAddress) => {
  if ((isStringEmpty(address.id) || !isString(address.id))) {
    return Promise.reject(10012)
  }
  return new Promise<WAddress>((resolve, reject) => {
    request<WAddress, WAddress>(APP_APIS.addressUpdate(address.id ?? ''), { params: { body: address } })
      .then(res => resolve(res.body))
      .catch(err => reject(err))
  })
}

export const addressDel = (id: string) => {
  if ((isStringEmpty(id) || !isString(id))) {
    return Promise.reject(10012)
  }
  return new Promise<void>((resolve, reject) => {
    request<void>(APP_APIS.addressDel(id))
      .then((_) => resolve())
      .catch(err => reject(err))
  })
}